export default __webpack_public_path__ + "static/filewithwaxdust-4fe6cac622b096bcad59aa230e670066.png";